import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import OverviewShell from '../overview_shell/OverviewShell';

const style = require('./SupplierWalkthroughOverviewPage.less');

const SupplierWalkthroughOverviewPage: FC<any> = ({ history, childRoutes }): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/supplier/walkthroughs/overview/${key}`),
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{
			key: 'all',
			name: 'All',
		},
	];

	return (
		<>
			<Route
				path="/supplier/walkthroughs/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/supplier/walkthroughs/overview/all',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Walkthroughs"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="supplierWalkthroughsPage"
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(SupplierWalkthroughOverviewPage)
);
